var React = require('react');

function Whitearrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.5","cy":"13","r":"12.5","fill":"white","key":0}),React.createElement("path",{"d":"M17.8536 13.3536C18.0488 13.1583 18.0488 12.8417 17.8536 12.6464L14.6716 9.46447C14.4763 9.2692 14.1597 9.2692 13.9645 9.46447C13.7692 9.65973 13.7692 9.97631 13.9645 10.1716L16.7929 13L13.9645 15.8284C13.7692 16.0237 13.7692 16.3403 13.9645 16.5355C14.1597 16.7308 14.4763 16.7308 14.6716 16.5355L17.8536 13.3536ZM6.25 13.5H17.5V12.5H6.25V13.5Z","fill":"black","key":1})]);
}

Whitearrow.defaultProps = {"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"};

module.exports = Whitearrow;

Whitearrow.default = Whitearrow;
